// ** Menu Components Imports
import HorizontalNavMenuLink from "./HorizontalNavMenuLink"
import HorizontalNavMenuGroup from "./HorizontalNavMenuGroup"
import { canViewMenuGroup, resolveHorizontalNavMenuItemComponent as resolveNavItemComponent } from "../../../../layouts/utils"
import { AbilityContext } from "../../../../../utility/context/Can"
import { useContext } from "react"

const HorizontalNavMenuItems = (props) => {
  const ability = useContext(AbilityContext)

  // ** Components Object
  const Components = {
    HorizontalNavMenuGroup,
    HorizontalNavMenuLink
  }

  // ** Render Nav Items
  const RenderNavItems = props.items.map((item, index) => {
    const TagName = Components[resolveNavItemComponent(item)]
    if (item.children) {
      return (
        canViewMenuGroup(item, ability) && (
          <TagName item={item} index={index} key={item.id} {...props} />
        )
      )
    }
    return <TagName item={item} index={index} key={item.id} {...props} />
  })

  return RenderNavItems
}

export default HorizontalNavMenuItems
